var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m44.72 33.12-18.666 12a1.322 1.322 0 0 1-1.359.05A1.331 1.331 0 0 1 24 44V20a1.332 1.332 0 0 1 2.055-1.12l18.666 12a1.333 1.333 0 0 1 0 2.243l-.001-.002Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32 0C14.354 0 0 14.355 0 32s14.354 32 32 32 32-14.355 32-32S49.646 0 32 0Zm12.721 33.121-18.666 12a1.322 1.322 0 0 1-1.359.05 1.331 1.331 0 0 1-.695-1.17v-24a1.332 1.332 0 0 1 2.055-1.121l18.666 12a1.333 1.333 0 0 1 0 2.243v-.002Z",
    fill: "#1E2022"
  })));
};
export default SvgPlay;